import React from 'react';
import './Footer.scss';
import logo from '../../../assets/images/dominionLogo.svg';
import face from '../../../assets/images/icons/Facebook.svg';
import instagram from '../../../assets/images/icons/Instagram.svg';
import linkedin from '../../../assets/images/icons/Linkedin.svg';
import twitter from '../../../assets/images/icons/Twitter.svg';
import youtube from '../../../assets/images/icons/Youtube.svg';

const Footer = () => {
  const mobile = window.innerWidth < 911;

  return (
    <footer className="Footer">
      <div className="container">
        <div className="social-container">
          <a
            href="https://www.facebook.com/dominionenergy"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={face} alt="Dominion Facebook" />
          </a>
          <a
            href="https://www.instagram.com/dominionenergy"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="Dominion Instagram" />
          </a>
          <a
            href="https://www.linkedin.com/company/dominionenergy/"
            aria-label="LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="Dominion LinkedIn" />
          </a>
          <a
            href="https://twitter.com/dominionenergy"
            aria-label="Twitter"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitter} alt="Dominion Twitter" />
          </a>
          <a
            href="https://www.youtube.com/dominionenergy"
            aria-label="Youtube"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={youtube} alt="Dominion Youtube" />
          </a>
        </div>
        {!mobile ? (
          <>
            <div className="text-container">
              <p className="mb-0">
                For more information about EVs and charging, email us at{' '}
                <a href="mailto:electrification@dominionenergy.com">
                  electrification@dominionenergy.com
                </a>
              </p>
            </div>
            <div className="disclaimer-container">
              <p>© 2026 J.D. Power and its affiliates. All Rights Reserved</p>
            </div>
          </>
        ) : (
          <div className="mobile-disclaimer-container">
            <p>© 2026 J.D. Power and its affiliates. All Rights Reserved</p>
          </div>
        )}
        {!mobile && (
          <div className="logo-container">
            <img src={logo} alt="Dominion Energy" />
          </div>
        )}
        <div className="text-container">
          <p>
            Figures shown on this page are estimates based on data provided by
            third-parties. This material is provided for informational purposes
            only and should not be relied on for tax, legal, or financial
            advice. Neither J.D. Power® nor Dominion Energy provide tax, legal
            or financial advice. You should independently verify the estimates
            provided here before engaging in any transaction.
          </p>
        </div>

        {mobile && (
          <div className="logo-container">
            <img src={logo} alt="Dominion Energy" />
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
